import * as types from "./types";

export default {
  [types.SET_ACCESSOBJECT](state, payload) {
    state.currentAccessObject = payload;
  },
  [types.SET_ACCESSRULELIST](state, payload) {
    state.accessRuleList = payload;
  }
};
